// src/pages/admin/Categories.js
import React from "react";
import AdminCategoriesComp from "../../components/Admin/AdminCategories";

export default function AdminCategoriesPage() {
  return <AdminCategoriesComp />;
}
